import useBcFolderStore from '@/frontapp/store/bcFolder'

export default async function (item, $store, $formValues) {
  $formValues['frm-editForm-editForm-name'] = item.name
  $formValues['frm-editForm-editForm-rank'] = item.rank
  $formValues['frm-editForm-editForm-icon_text'] = item.icon_text
  $formValues['frm-editForm-editForm-icon_bg_color'] = item.icon_bg_color
  $formValues['frm-editForm-editForm-icon_text_color'] = item.icon_text_color
  $formValues['frm-editForm-editForm-id:change'] = item.id
  $formValues['frm-editForm-editForm-element_type:change'] = item.type

  if (item.type === 'folder') {
    $formValues['frm-editForm-editForm-bc_folder_id'] = item.parent__bc_folder_id
    $formValues['frm-editForm-editForm-link'] = item.link
    $formValues['frm-editForm-editForm-header__file_id'] = item.header__file 
      ? item.header__file.id
      : null
    
    $store.commit('nette/updateControl', {
      controlName: 'frm-editForm-editForm-header__file_id',
      data: item.header__file,
      key: 'file',
    })

    setTimeout(() => {
      window.document.getElementById('frm-editForm-editForm-name').focus()
    }, 100)

    await useBcFolderStore().loadFolder(item.id)
  
  } else {
    $formValues['frm-editForm-editForm-bc_folder_id'] = item.bc_folder_id
  }

  $formValues['frm-editForm-editForm-image__file_id'] = item.image__file 
    ? item.image__file.id
    : null
  
  $store.commit('nette/updateControl', {
    controlName: 'frm-editForm-editForm-image__file_id',
    data: item.image__file,
    key: 'file',
  })

  $store.commit('nette/updateControl', {
    controlName: 'editForm',
    data: true,
    key: 'showModal',
  })

  setTimeout(() => {
    window.document.getElementById('frm-editForm-editForm-name').focus()
  }, 100)
}